import GraphicStandTableFilter from './graphic-stand-table-filter';

const GraphicStandFilters = {
    Table: GraphicStandTableFilter
};

export default GraphicStandFilters;